<h3 class="text-center" *ngIf="showHeadings">Salget til månedens trækning slutter om</h3>
<div [ngClass]="{'mt-4 mb-4': !useAlternate}">
  <countdown [countdownDate]="time" #countdown [showAllCountdownBlocks]="showAllCountdownBlocks"
    [useAlternate]="useAlternate" [makeFlex]="makeFlex" [yellowTiles]="yellowTiles"></countdown>
</div>
